import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconBookmarkFilled = ({ id, color, width = 30, style, ...restProps }: IProps) => {
  const viewBoxWidth = 30;
  const viewBoxHeight = 50;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        fillRule="evenodd"
        d="M27.682 50a2.392 2.392 0 0 1-1.5-.522L15 40.493 3.818 49.478a2.422 2.422 0 0 1-2.473.319C.525 49.436 0 48.659 0 47.803V2.197C0 .984 1.039 0 2.318 0h25.364C28.962 0 30 .984 30 2.197v45.606c0 .856-.524 1.633-1.345 1.994a2.439 2.439 0 0 1-.973.203z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconBookmarkFilled;
